export const BRAND_NAME = 'Kurrate';
export const BRAND_WORDMARK = 'kurrate';
export const BRAND_LEGAL_NAME = 'Kurrate, Inc.';
